window.bundleDataH = {
"Hailey-girl": {
displayName: "Hailey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hailey Personalized Coloring Experience",
variantId: "49508368548077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hailey_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Hailey Unicorn Holographic Sticker",
variantId: "49933757776109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hailey_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Hailey Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Hallie-girl": {
displayName: "Hallie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hallie Personalized Coloring Experience",
variantId: "49508309041389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hallie_final_cover.png?v=1773105078",
price: "$14.99",
preorder: true
},
{
title: "Hallie Unicorn Holographic Sticker",
variantId: "49933758005485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hallie_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Hallie Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Hannah-girl": {
displayName: "Hannah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hannah Personalized Coloring Experience",
variantId: "49508357243117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hannah_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Hannah Unicorn Holographic Sticker",
variantId: "49933757874413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hannah_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Hannah Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Harlow-girl": {
displayName: "Harlow",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Harlow Personalized Coloring Experience",
variantId: "49754425065709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harlow_final_cover.png?v=1775322362",
price: "$14.99",
preorder: true
},
{
title: "Harlow Unicorn Holographic Sticker",
variantId: "49933752926445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harlow_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Harlow Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Harper-girl": {
displayName: "Harper",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Harper Personalized Coloring Experience",
variantId: "49508311171309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harper_final_cover.png?v=1773105078",
price: "$14.99",
preorder: true
},
{
title: "Harper Unicorn Holographic Sticker",
variantId: "49933757972717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harper_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Harper Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Harrison-boy": {
displayName: "Harrison",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Harrison Personalized Coloring Experience",
variantId: "49400135450861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harrison_final_cover.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Harrison Dragon Holographic Sticker",
variantId: "49933769605357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harrison_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Harrison Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Hayes-boy": {
displayName: "Hayes",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hayes Personalized Coloring Experience",
variantId: "49472196608237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hayes_final_cover.png?v=1772930021",
price: "$14.99",
preorder: true
},
{
title: "Hayes Dragon Holographic Sticker",
variantId: "49933758955757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hayes_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Hayes Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Hazel-girl": {
displayName: "Hazel",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hazel Personalized Coloring Experience",
variantId: "49537096286445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hazel_final_cover.png?v=1773200665",
price: "$14.99",
preorder: true
},
{
title: "Hazel Unicorn Holographic Sticker",
variantId: "49933757743341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hazel_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Hazel Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Henry-boy": {
displayName: "Henry",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Henry Personalized Coloring Experience",
variantId: "49343633686765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Henry_final_cover.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Henry Dragon Holographic Sticker",
variantId: "49933771145453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Henry_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Henry Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Hudson-boy": {
displayName: "Hudson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hudson Personalized Coloring Experience",
variantId: "49279569199341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hudson_final_cover_1efc2d7c-6c18-48ea-9771-1260820120e3.png?v=1772483900",
price: "$14.99",
preorder: true
},
{
title: "Hudson Dragon Holographic Sticker",
variantId: "49933775732973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hudson_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Hudson Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Hunter-boy": {
displayName: "Hunter",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hunter Personalized Coloring Experience",
variantId: "49343637553389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hunter_final_cover.png?v=1772483901",
price: "$14.99",
preorder: true
},
{
title: "Hunter Dragon Holographic Sticker",
variantId: "49933770916077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hunter_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Hunter Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Heidi-girl": {
displayName: "Heidi",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Heidi Personalized Coloring Experience",
variantId: "50042451722477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Heidi_final_cover.png?v=1780107496",
price: "$14.99",
preorder: true
},
{
title: "Heidi Unicorn Holographic Sticker",
variantId: "50042186531053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Heidi_holographic_sticker.png?v=1780099044",
price: "$4.99",
preorder: false
},
{
title: "Heidi Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Hadley-girl": {
displayName: "Hadley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hadley Personalized Coloring Experience",
variantId: "50056820883693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hadley_final_cover.png?v=1780209145",
price: "$14.99",
preorder: true
},
{
title: "Hadley Unicorn Holographic Sticker",
variantId: "50056878162157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hadley_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Hadley Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Hayden-boy": {
displayName: "Hayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Hayden Personalized Coloring Experience",
variantId: "50127690793197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Haydenfinalcover.png?v=1781987917",
price: "$14.99",
preorder: true
},
{
title: "Hayden Dragon Holographic Sticker",
variantId: "50127670837485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Hayden_website_sticker.png?v=1781987000",
price: "$4.99",
preorder: false
},
{
title: "Hayden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Holden-boy": {
displayName: "Holden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Holden Personalized Coloring Experience",
variantId: "50449688002797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Holden_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Holden Dragon Holographic Sticker",
variantId: "50449583964397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Holden_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Holden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Harmony-girl": {
displayName: "Harmony",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Harmony Personalized Coloring Experience",
variantId: "50519282745581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harmony_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Harmony Unicorn Holographic Sticker",
variantId: "50497557070061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Harmony_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Harmony Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Haven-girl": {
displayName: "Haven",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Haven Personalized Coloring Experience",
variantId: "50643937853677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Haven_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Haven Unicorn Holographic Sticker",
variantId: "50643950108909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Haven_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Haven Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 







};